import { IUserAccountStore } from '../../index'

export default function(store: IUserAccountStore): IUserAccountStore {
  return {
    ...store,
    notifications: {
      ...store.notifications,
      isLoading: true,
    },
  }
}
